import moment from 'moment';

class ZDate extends Date {
  constructor(...args) {
    if (args.length === 1) {
      const input = args[0];
      if (input === null) {
        super(input);
        return;
      }

      const isPlainObject = typeof input === 'object' && !(input instanceof Date);
      if (isPlainObject) {
        const dateKeys = ['year', 'month', 'day', 'date', 'hour', 'minute', 'second', 'millisecond'];
        const isValidMomentObjectInput = Object.keys(input).every(key => dateKeys.includes(key));
        if (!isValidMomentObjectInput) {
          super(input);
          return;
        }
      }

      const momentObj = moment(input);

      if (!momentObj.isValid()) {
        super(input);
      } else {
        super(momentObj.valueOf());
      }
    } else {
      super(...args);
    }
  }
}

globalThis.ZDate = ZDate;
export default ZDate;